// extracted by mini-css-extract-plugin
module.exports = {"noBr":"ArticleTitle-module--noBr--3lJQf","container":"ArticleTitle-module--container--3HfhT","title":"ArticleTitle-module--title--1pzn9","date":"ArticleTitle-module--date--22MEU"};